import React, { useState, useEffect, useRef } from 'react'
import { nanoid } from "nanoid"
import Button from '@mui/material/Button';
import { useNavigate } from "react-router-dom"
import { toast, Toaster } from 'sonner';
import { BiLoader } from "react-icons/bi"
import api from '../../controller/api';
// import 'primereact/resources/themes/fluent-light/theme.css';

import { MultiSelect } from 'primereact/multiselect';

export default function ProductAdd() {
    const [category, setCategory] = useState([])

    const [categoryId, setCategoryId] = useState("");
    const [title, setTitle] = useState("");
    const [file, setFile] = useState("")
    const [voice, setVoice] = useState([])
    const [price, setPrice] = useState()
    const [experience, setExperience] = useState()
    const [loading, setLoading] = useState(false)

    const languages = [
        { name: 'Hindi' },
        { name: 'English' },
        { name: 'Bengala' },
        { name: 'Marathi' },
        { name: 'Tamil' },
        { name: 'Telugu' },
        { name: 'Malyalam' },
        { name: 'Urdu' },
    ];

    const navigate = useNavigate()
    const inputFile = useRef(null);

    const clearInput = () => {
        setCategoryId("")
        setTitle("")
        setPrice()
        setExperience()
        inputFile.current.value = "";
    };

    const handleAddProduct = async (e) => {
        e.preventDefault();
        setLoading(true)
        const language = voice.map(item => item.name);
        //console.log(values);
        try {
            const formData = new FormData()
            formData.append("file", file);
            formData.append("categoryId", categoryId);
            formData.append("title", title);
            formData.append("price", price);
            formData.append("experience", experience);
            formData.append("language", language);

            const { data: res } = await api.post("/product/create", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            })
            toast.success("Doctor added")
            clearInput()
        } catch (error) {
            console.error(error)
            toast.error(error?.response?.data?.message)
        } finally {
            setLoading(false)
        }
    }

    const fetchCategory = async () => {
        try {
            const { data: res } = await api.get("/category/list")
            setCategory(res.data)
        } catch (error) {
            console.error(error?.response?.data?.message);
            if (error?.response?.data?.message === "jwt expired") {
                localStorage.removeItem("user");
                window.location.reload();
            }
        }
    }

    const categoryList = category.map((category) => <option key={category._id} value={category._id}>{category.categoryName}</option>)

    useEffect(() => {
        fetchCategory()

    }, [])
    return (
        <div className='manage'>
            <Toaster richColors position="top-center" />
            <h2 style={{ display: "flex", justifyContent: "space-between" }}>
                Create Doctor
                <Button variant="contained" onClick={() => navigate("/dashboard/products")}>Back to List</Button>
            </h2>
            <div className='add-product'>
                <form onSubmit={handleAddProduct}>
                    <div className='form-row'>
                        <div className='inpt-row'>
                            <label>Name</label>
                            <input type='text' value={title} onChange={(e) => setTitle(e.target.value)} required />
                        </div>
                        <div className='inpt-row'>
                            <label>Fees</label>
                            <input type='number' value={price} onChange={(e) => setPrice(e.target.value)} />
                        </div>
                    </div>
                    <div className='form-row'>
                        <div className='inpt-row'>
                            <label>Experience</label>
                            <input type='number' value={experience} onChange={(e) => setExperience(e.target.value)} />
                        </div>
                        <div className='inpt-row'>
                            <label>Language Known</label>
                            {/* <input type='number' value={language} onChange={(e) => setLanguage(e.target.value)} /> */}
                            <MultiSelect value={voice} onChange={(e) => setVoice(e.value)} options={languages} optionLabel="name"
                                placeholder="Select Language" maxSelectedLabels={3} className="w-full md:w-20rem" />
                        </div>
                    </div>
                    <div className='form-row'>
                        <div className='inpt-row'>
                            <label>Category</label>
                            <select name='categoryId' value={categoryId} onChange={(e) => setCategoryId(e.target.value)}>
                                <option>Select Category</option>
                                {categoryList}
                            </select>
                        </div>
                        <div className='inpt-row'>
                            <label>UPLOAD PHOTO</label>
                            <input type='file' ref={inputFile} onChange={(e) => setFile(e.target.files[0])} />
                        </div>
                    </div>
                    <Button type='submit' variant="contained" disableElevation>
                        {loading ? <BiLoader size={24} className='animate-spin' /> : "Create Doctor"}
                    </Button>
                </form>
            </div>
        </div>
    )
}
